import React from 'react';
import { RefreshCw } from 'lucide-react';

export const AutomaticSync = () => {
  return (
    <div className="p-8 max-w-4xl mx-auto">
      <div className="mb-8 flex items-center gap-3">
        <RefreshCw className="w-8 h-8 text-gray-700" />
        <h1 className="text-2xl font-semibold text-gray-900">Sincronización Automática</h1>
      </div>
      
      <div className="bg-white rounded-lg p-8 shadow-sm">
        <p className="text-gray-600">Esta funcionalidad estará disponible próximamente.</p>
      </div>
    </div>
  );
};